// material-ui
import { styled } from '@mui/material/styles';

// ==============================|| AUTHENTICATION 1 WRAPPER ||============================== //

const Wrapper = styled('div')(({ theme }) => ({
    backgroundColor: "#FFFDFA",
    minHeight: '100dvh'
}));

export default Wrapper;